import { render, staticRenderFns } from "./BlockCntr.vue?vue&type=template&id=502bf8ee&scoped=true&"
import script from "./BlockCntr.vue?vue&type=script&lang=js&"
export * from "./BlockCntr.vue?vue&type=script&lang=js&"
import style0 from "./BlockCntr.vue?vue&type=style&index=0&id=502bf8ee&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "502bf8ee",
  null
  
)

export default component.exports